<template>
  <div class="home">
    <div class="wrap">
      <!-- 自定义时间 -->
      <div class="date-time">
        <label>自定义时间</label>
        <el-date-picker
          v-model="times"
          type="daterange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="datePickerConfig.pickerOptions"
          @change="statistics"
        >
        </el-date-picker>
      </div>
      <!-- 统计结果 -->
      <ul class="numbers">
        <li>
          <em style="color: red;"><Value :data="countData" prop="unCollect"/></em>
          <label>待收款案例数</label>
        </li>
        <li>
          <em><Value :data="countData" prop="project"/></em>
          <label>下单案例数</label>
        </li>
        <li>
          <em><Value :data="countData" prop="delivery"/></em>
          <label>已交付案例数</label>
        </li>
        <li>
          <em><Value :data="countData" prop="unDelivery"/></em>
          <label>未交付案例数</label>
        </li>
      </ul>
      <!-- 排行榜 -->
      <div class="ranking-list">
        <h2>交付排行榜</h2>
        <Loading v-if="deliveryUserData.loading"/>
        <EmptyTip v-else-if="deliveryUserData.list.length === 0">暂无人员交付</EmptyTip>
        <ul v-else>
          <li v-for="(user,i) in deliveryUserData.list" :key="user.userId">
            <label>{{user.realname}}</label>
            <em>{{user.count}}</em>
            <span class="ranking-number">{{i + 1}}</span>
          </li>
          <li v-for="i in 5 - deliveryUserData.list.length % 5" :key="i" class="holder"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyTip from '@/components/common/EmptyTip'
import Value from '@/components/common/Value'
import Loading from '@/components/common/Loading'
import { count, countUserDelivery } from '@/api/customer/project'

export default {
  name: 'Index',
  components: { Loading, Value, EmptyTip },
  data () {
    return {
      times: [],
      form: {
        // 开始时间
        startTime: '',
        // 结束时间
        endTime: ''
      },
      // 限制只能选今天
      datePickerConfig: {
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() > Date.now() // 如果没有后面的-8.64e6就是不可以选择今天的
          }
        }
      },
      // 统计数
      countData: {
        project: null,
        delivery: null,
        unDelivery: null,
        unCollect: null
      },
      // 员工交付列表
      deliveryUserData: {
        loading: false,
        list: []
      }
    }
  },
  methods: {
    // 统计
    statistics (times = []) {
      if (times != null) {
        this.form.startTime = times[0]
        this.form.endTime = times[1]
      }
      this.countProject()
      this.countDelivery()
      this.countUnCollect()
      this.countUnDelivery()
      this.countUserDelivery()
    },
    // 下单数
    countProject () {
      this.__count(null, null, 'project')
    },
    // 交付
    countDelivery () {
      this.__count('COMPLETE', null, 'delivery')
    },
    // 未收款
    countUnCollect () {
      this.__count(null, 'UNPAY', 'unCollect')
    },
    // 未交付
    countUnDelivery () {
      this.countData.unDelivery = null
      Promise.all([
        count({
          ...this.form,
          status: 'WAIT'
        }),
        count({
          ...this.form,
          status: 'MAKING'
        })
      ])
        .then(data => {
          // 每次执行时给他归零
          this.countData.unDelivery = 0
          for (const sum of data) {
            this.countData.unDelivery += sum
          }
        })
    },
    // 查询用户交付数
    countUserDelivery () {
      this.deliveryUserData.loading = true
      countUserDelivery(this.form)
        .then(data => {
          this.deliveryUserData.list = data
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.deliveryUserData.loading = false
        })
    },
    // 统计
    __count (status, payStatus, countKey) {
      count({
        ...this.form,
        status,
        payStatus
      })
        .then(data => {
          this.countData[countKey] = data
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    }
  },
  created () {
    this.statistics()
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/style/variables.scss";
.home {
  padding: 0 20px;
  .wrap {
    width: 900px;
    margin: 20px auto;
    display: flex;
    flex-direction: column;
    // 日期选择
    .date-time {
      display: flex;
      justify-content: center;
      align-items: center;
      label {
        margin-right: 10px;
        font-size: 14px;
      }
    }
    // 数量
    .numbers {
      width: 900px;
      margin: 20px 0;
      display: flex;
      justify-content: space-between;
      li {
        width: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        border-radius: 20px;
        padding: 30px 0;
        em {
          font-size: 35px;
          font-weight: bold;
        }
        label {
          margin-top: 10px;
          color: #888;
        }
      }
    }
    // 交付排行榜
    .ranking-list {
      background-color: #fff;
      padding: 20px;
      h2 {
        font-size: 16px;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      li {
        background-color: #f7f7f7;
        margin-top: 20px;
        width: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 30px 0;
        position: relative;
        em {
          font-size: 30px;
          font-weight: bold;
        }
        label {
          margin-top: 10px;
          color: #888;
        }
        .ranking-number {
          position: absolute;
          top: 0;
          left: 0;
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #ccc;
          color: #666;
        }
        &:nth-of-type(1) .ranking-number {
          background-color: red;
          color: #fff;
          font-weight: bold;
        }
        &:nth-of-type(2) .ranking-number {
          background-color: orangered;
          color: #fff;
          font-weight: bold;
        }
        &:nth-of-type(3) .ranking-number {
          background-color: orange;
          color: #fff;
          font-weight: bold;
        }
        &.holder {
          background-color: transparent;
        }
      }
    }
  }
}
</style>
